@if (guia1.length != 0) {
  <app-guia-component [GUIA_KEY]="'GUIA I'" [data]="guia1"></app-guia-component>
}
@else {
  <app-empty-state [message] = "guideContent()?.emptyStateMessage"></app-empty-state>
  <br>
}
<div class="container-btn">
  <button type="button" (click)="handleGoBack()">{{guideContent()?.backButton}}</button>
</div>
